export default "__VITE_ASSET__BDjPzrYx__"